export default __webpack_public_path__ + "static/media/special-application-banner.d4415daa.jpg";